import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import PatientsTable from './components/PatientsTable';
import ConnectedProjectProfileDialog from './components/ConnectedProjectProfileDialog';
import { clearDocumentsDefaultProjectId } from '../../utils/documentsDefaultProjectId';

const PatientsDirectory = () => {
  const dispatch = useDispatch();

  const handleOnSubmitted = useCallback(
    ({ recipientId }) => {
      // Project-agnostic entry point — clear any sticky project default so
      // the Documents tab shows all projects, not a stale one.
      clearDocumentsDefaultProjectId(recipientId);
      dispatch(push(`/patients/${recipientId}`));
    },
    [dispatch],
  );

  return (
    <>
      <ConnectedProjectProfileDialog onSubmitted={handleOnSubmitted} />
      <PatientsTable />
    </>
  );
};

export default PatientsDirectory;
